const JsAddThis = {
  init () {

    /*              __
                   / _)         
            .-^^^-/ /          
        __/       /              
        <__.|_|-|_|  

        The Emagine Dinosaur says; "Sharing is caring, we care so much, we're using 'add this' to share. http://www.addthis.com/".          
    */

    // https://codepen.io/samc36/pen/PepgbO
    // https://codepen.io/fishgraphics/pen/pJzEpY
    if ( $('.e-button-share').length ) {
      var addthis_config = {
        ui_click: true 
      } 

      // Do this when the AddThis API is ready
      function addthisReady(evt) {
        // Place the color of your website here.
        var websiteColor = "#749EAC";

        // This changes the color once the "addThis" buttons have been loaded    
        $('.addthis_toolbox > a').find('span').css("background-color", websiteColor);
      }

      // Listen for the ready event
      addthis.addEventListener('addthis.ready', addthisReady);

      $('.addthis_toolbox > a').hover(function() {
        $('.addthis_toolbox > a').not(this).stop().fadeTo( "fast" , 0.3);
      }, function() {
        $('.addthis_toolbox > a').not(this).stop().fadeTo( "fast" , 1);
      });
    }

  }
};

export default JsAddThis;


// WEBPACK FOOTER //
// ./src/js/modules/add-this.js